import { render, staticRenderFns } from "./takeNotes.vue?vue&type=template&id=774466dd&scoped=true&"
import script from "./takeNotes.vue?vue&type=script&lang=js&"
export * from "./takeNotes.vue?vue&type=script&lang=js&"
import style0 from "./takeNotes.vue?vue&type=style&index=0&id=774466dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774466dd",
  null
  
)

export default component.exports